export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: 'zone1' | 'zone2' | 'contest';
  categoryName: string;
  image: string;
  date: string;
  views: number;
  tags: string[];
  author: string;
  isHot: boolean;
  isNew: boolean;
}

export const articleCategories = [
  { key: 'zone1' as const, name: '黑料一区', slug: 'zone1', description: '最新鲜的一手黑料爆料，娱乐圈与网红圈深度揭秘' },
  { key: 'zone2' as const, name: '黑料二区', slug: 'zone2', description: '更多劲爆内容集中地，持续追踪热点事件' },
  { key: 'contest' as const, name: '每日大赛专区', slug: 'contest', description: '黑料大赛每日精选，用户投票评选最劲爆黑料' },
];

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '某知名网红直播翻车现场全记录，背后真相令人震惊',
    excerpt: '近日一位拥有千万粉丝的网红在直播过程中意外翻车，直播间弹幕瞬间炸锅。据知情人士透露，这背后隐藏着更多不为人知的故事...',
    content: `<p>近日，一位拥有千万粉丝级别的知名网红在直播过程中发生了令人瞠目结舌的翻车事件。据悉，该网红当时正在进行一场品牌合作直播，直播间在线人数一度突破50万。</p><p>然而就在直播进行到一半时，一个突如其来的画面让整个直播间陷入了混乱。画面中出现了与该网红此前塑造的完美人设完全不符的内容，弹幕瞬间炸开了锅。</p><p>据知情人士透露，这次翻车并非偶然。背后涉及的品牌利益纠葛、团队内部矛盾以及该网红近期的种种异常行为，都指向了一个更大的故事。</p><p>有网友翻出了该网红近半年来的社交媒体动态，发现了多处前后矛盾的细节。更有业内人士爆料称，该网红的团队内部早已出现严重分歧，这次直播事故只是冰山一角。</p><p>目前，该网红的社交媒体账号评论区已被网友攻陷，相关话题在各大平台热搜榜上持续攀升。品牌方也已紧急发布声明，表示将彻查此事。</p>`,
    category: 'zone1',
    categoryName: '黑料一区',
    image: 'https://readdy.ai/api/search-image?query=dark%20dramatic%20live%20streaming%20studio%20scene%20with%20shocked%20expression%20silhouette%2C%20red%20and%20black%20color%20palette%2C%20mysterious%20atmosphere%2C%20dramatic%20lighting%2C%20digital%20screen%20glow%2C%20cinematic%20composition%2C%20dark%20background%20with%20subtle%20texture%2C%20editorial%20style%20photography&width=800&height=450&seq=article-zone1-01&orientation=landscape',
    date: '2026-08-03',
    views: 128500,
    tags: ['网红翻车', '直播事故', '娱乐圈', '品牌危机'],
    author: '黑料观察员',
    isHot: true,
    isNew: true,
  },
  {
    id: 'article-2',
    title: '某顶流明星私密聚会照片流出，圈内人士集体沉默',
    excerpt: '一组疑似某顶流明星参加私人派对的照片在社交平台疯传，多位圈内人士对此事保持沉默，引发网友广泛猜测...',
    content: `<p>昨日晚间，一组疑似某顶流明星参加私人派对的照片在社交平台疯传。照片中的人物虽然面部被打了码，但从身形、衣着和周围环境的细节来看，与某位当红明星高度吻合。</p><p>这组照片最早出现在一个匿名爆料账号上，随后被大量转发。令人玩味的是，多位与该明星有合作关系的圈内人士对此事集体保持沉默，既不出面否认，也不发表任何评论。</p><p>有资深娱记分析认为，这种集体沉默本身就是一种信号。在娱乐圈，当所有人都选择不出声的时候，往往意味着事情的真实性已经不需要质疑。</p><p>更值得注意的是，照片中的聚会场景似乎涉及一些不太适合公开讨论的内容。有网友通过放大照片细节，发现了一些令人遐想的线索。</p><p>截至目前，该明星的工作室尚未对此事做出任何回应。但其社交媒体账号的最新动态评论区已经被网友留言淹没了。</p>`,
    category: 'zone1',
    categoryName: '黑料一区',
    image: 'https://readdy.ai/api/search-image?query=exclusive%20party%20scene%20with%20mysterious%20silhouettes%2C%20dim%20ambient%20lighting%2C%20luxury%20interior%2C%20dramatic%20shadows%2C%20dark%20moody%20atmosphere%2C%20cinematic%20noir%20style%2C%20red%20accent%20lighting%2C%20mysterious%20composition&width=800&height=450&seq=article-zone1-02&orientation=landscape',
    date: '2026-08-03',
    views: 98700,
    tags: ['顶流明星', '私密聚会', '照片泄露', '圈内沉默'],
    author: '深夜爆料君',
    isHot: true,
    isNew: false,
  },
  {
    id: 'article-3',
    title: '某知名企业高管内部邮件曝光，涉及重大商业机密',
    excerpt: '一份据称来自某知名科技公司高管的内部邮件今日被曝光，邮件内容涉及多项重大商业决策和企业内部矛盾...',
    content: `<p>今日，一份据称来自某知名科技公司高管的内部邮件在网络上被曝光。这份邮件的收件人包括公司多位核心管理层成员，内容涉及多项重大商业决策以及企业内部存在的深层矛盾。</p><p>邮件中详细提到了该公司在近期几个重要项目中的决策过程，以及对竞争对手的策略评估。其中一些内容如果属实，可能会对该公司的股价产生重大影响。</p><p>更引人关注的是，邮件中还提到了公司内部几个部门之间的权力斗争。有分析人士指出，这封邮件的泄露很可能就是内部斗争的结果之一。</p><p>目前，该公司公关部门尚未对此事做出正式回应。但据了解，公司法务团队已经开始着手调查邮件泄露的源头。</p><p>业内专家表示，如果这封邮件的内容属实，将对整个行业格局产生深远影响。相关监管机构可能也会介入调查。</p>`,
    category: 'zone2',
    categoryName: '黑料二区',
    image: 'https://readdy.ai/api/search-image?query=confidential%20business%20document%20on%20dark%20desk%2C%20dramatic%20office%20lighting%2C%20corporate%20secrecy%20theme%2C%20dark%20suit%20silhouette%2C%20mysterious%20business%20atmosphere%2C%20red%20stamp%20markings%2C%20night%20office%20scene%2C%20film%20noir%20style&width=800&height=450&seq=article-zone2-01&orientation=landscape',
    date: '2026-08-02',
    views: 76500,
    tags: ['企业内部', '邮件泄露', '商业机密', '科技公司'],
    author: '商业观察家',
    isHot: true,
    isNew: false,
  },
  {
    id: 'article-4',
    title: '某综艺节目幕后黑幕大起底，导演组疑似操控比赛结果',
    excerpt: '多位参与过某热门综艺节目的选手匿名爆料，称节目组存在操纵比赛结果的行为，引发观众对节目公正性的质疑...',
    content: `<p>近日，多位参与过某热门综艺节目的选手通过匿名方式向本网爆料，称该节目存在严重的幕后操控行为。据这些选手透露，比赛结果往往在录制之前就已经被导演组内定。</p><p>一位不愿透露姓名的前参赛选手表示："观众看到的激烈竞争和紧张淘汰，其实都是剧本安排好的。真正的结果早就确定了，我们在台上只是在演戏而已。"</p><p>还有选手爆料称，节目中那些看似偶然的"冲突"和"争议"，实际上都是导演组精心设计的剧情。每位选手都有自己的"人设"，需要在节目中按照既定的方向去表演。</p><p>更令人震惊的是，据称节目组还会通过与选手签订不平等合同的方式，来控制选手的言行。如果有选手不配合，就会面临巨额违约金。</p><p>此爆料一出，立即在网络上引起轩然大波。大量观众表示感到被欺骗，要求节目组给出合理解释。</p>`,
    category: 'zone2',
    categoryName: '黑料二区',
    image: 'https://readdy.ai/api/search-image?query=reality%20TV%20show%20backstage%20drama%2C%20dark%20behind%20the%20scenes%2C%20spotlight%20with%20shadows%2C%20television%20studio%20set%2C%20dramatic%20contrast%20lighting%2C%20mysterious%20atmosphere%2C%20red%20curtain%20drapes%2C%20cinematic%20composition&width=800&height=450&seq=article-zone2-02&orientation=landscape',
    date: '2026-08-02',
    views: 89200,
    tags: ['综艺黑幕', '比赛操控', '节目内幕', '选手爆料'],
    author: '综艺深喉',
    isHot: false,
    isNew: true,
  },
  {
    id: 'article-5',
    title: '每日大赛精选：本周最劲爆黑料TOP10排行榜',
    excerpt: '每日大赛专区本周精选呈现，经过数万网友投票评选出的十大劲爆黑料，每一则都令人瞠目结舌...',
    content: `<p>欢迎来到每日大赛专区本周特别企划！经过数万名网友的热情投票，我们为大家精选了本周最劲爆的十大黑料，每一则都让人难以置信。</p><p><strong>第一名：某品牌代言人合同纠纷内幕</strong><br>一份代言合同的细节被曝光，其中涉及的条款之苛刻令人咋舌。据业内人士分析，这种合同在行业内其实相当普遍。</p><p><strong>第二名：网红孵化公司压榨旗下艺人</strong><br>多名签约网红联名举报，称公司存在严重压榨行为，包括超长工作时间、不合理分成比例以及人身限制等。</p><p><strong>第三名：某直播平台数据造假实锤</strong><br>技术人员通过数据分析发现，某知名直播平台存在大规模数据造假行为，虚拟观众比例高达60%以上。</p><p>本周的榜单竞争异常激烈，前三名之间的票数差距非常小。更多精彩内容，请持续关注每日大赛专区。</p>`,
    category: 'contest',
    categoryName: '每日大赛专区',
    image: 'https://readdy.ai/api/search-image?query=top%2010%20ranking%20list%20design%20with%20dark%20theme%2C%20golden%20trophy%20on%20dark%20background%2C%20dramatic%20spotlight%2C%20competition%20ranking%20visual%2C%20red%20and%20gold%20accents%2C%20luxurious%20dark%20atmosphere%2C%20award%20ceremony%20vibe&width=800&height=450&seq=article-contest-01&orientation=landscape',
    date: '2026-08-01',
    views: 156200,
    tags: ['每日大赛', 'TOP10', '本周精选', '投票排行'],
    author: '大赛评委会',
    isHot: true,
    isNew: true,
  },
  {
    id: 'article-6',
    title: '知名导演与女演员不伦恋曝光，片场亲密照流出',
    excerpt: '一组在某影视剧组片场拍摄的照片今日在网络疯传，照片中某知名导演与剧组女演员举止亲密，引发热议...',
    content: `<p>今日，一组在某影视剧组片场拍摄的照片在网络疯狂传播。照片清晰显示，某位已婚知名导演与剧组中的年轻女演员之间存在超出正常工作关系的亲密互动。</p><p>这组照片的拍摄时间跨度长达数月，地点涵盖片场、酒店以及私人聚会的场所。从照片内容来看，两人的关系显然已经不是单纯的导演与演员。</p><p>有剧组工作人员匿名透露，整个剧组其实都知道这件事，但没人敢说。导演在剧组中的权力极大，任何人都担心因为多嘴而丢掉工作。</p><p>该导演的妻子是一位同样在演艺圈活跃的知名演员，两人育有两个孩子，一直以来都以模范夫妻的形象示人。</p><p>目前，涉事双方均未对此事做出回应。但据知情人士透露，该导演的经纪团队正在紧急商讨危机公关方案。</p>`,
    category: 'zone1',
    categoryName: '黑料一区',
    image: 'https://readdy.ai/api/search-image?query=film%20set%20behind%20scenes%20dramatic%20moment%2C%20director%20chair%20in%20shadow%2C%20movie%20camera%20silhouette%2C%20dark%20cinematic%20lighting%2C%20romantic%20scandal%20theme%2C%20red%20accent%20light%2C%20mysterious%20film%20studio%20atmosphere%2C%20noir%20photography%20style&width=800&height=450&seq=article-zone1-03&orientation=landscape',
    date: '2026-08-01',
    views: 143800,
    tags: ['导演丑闻', '不伦恋', '片场爆料', '娱乐圈'],
    author: '影视圈探长',
    isHot: true,
    isNew: false,
  },
  {
    id: 'article-7',
    title: '某电商平台被爆大数据杀熟，老用户价格比新用户贵30%',
    excerpt: '一项针对某大型电商平台的调查发现，该平台存在明显的大数据杀熟现象，老用户看到的商品价格竟比新用户高出30%...',
    content: `<p>一项由消费者权益保护组织发起的调查今日公布了惊人结果：某大型电商平台存在严重的"大数据杀熟"行为。调查显示，同样的商品，平台老用户看到的价格比新注册用户平均高出30%。</p><p>调查团队使用了多个不同注册时间的账号进行对比测试，覆盖了手机、家电、服装、食品等多个品类。结果令人震惊——几乎所有测试品类都存在不同程度的价格差异。</p><p>更令人气愤的是，该平台会员用户看到的价格甚至比非会员更高。有会员用户在得知这一情况后表示："我们花钱买会员，结果反而被宰得更狠？"</p><p>法律专家指出，这种行为涉嫌违反《消费者权益保护法》和《个人信息保护法》。如果调查结果属实，该平台可能面临巨额罚款。</p><p>截至目前，该平台客服仅表示"不同用户可能因为优惠券等因素看到不同价格"，并未正面回应是否存在大数据杀熟行为。</p>`,
    category: 'zone2',
    categoryName: '黑料二区',
    image: 'https://readdy.ai/api/search-image?query=ecommerce%20price%20comparison%20concept%2C%20shopping%20cart%20with%20red%20warning%20sign%2C%20digital%20price%20tags%2C%20dark%20web%20shopping%20theme%2C%20dramatic%20technology%20atmosphere%2C%20red%20and%20dark%20color%20scheme%2C%20consumer%20rights%20concept&width=800&height=450&seq=article-zone2-03&orientation=landscape',
    date: '2026-07-31',
    views: 112400,
    tags: ['大数据杀熟', '电商平台', '消费者权益', '价格歧视'],
    author: '消费维权先锋',
    isHot: false,
    isNew: true,
  },
  {
    id: 'article-8',
    title: '每日大赛：谁是你心中本月最离谱的翻车事件？',
    excerpt: '本月娱乐圈和网红圈的翻车事件层出不穷，每日大赛专区发起投票，邀请网友评选出本月最离谱的翻车事件...',
    content: `<p>各位亲爱的网友们，又到了每日大赛专区的月度投票时间！过去一个月里，娱乐圈和网红圈的翻车事件可以说是精彩纷呈，让人目不暇接。</p><p><strong>候选事件一：某带货主播假货风波</strong><br>号称"全网最低价"的某头部带货主播，被消费者实锤售卖假冒品牌商品，涉及金额高达数千万元。</p><p><strong>候选事件二：某歌手演唱会假唱被当场揭穿</strong><br>在一场万人演唱会上，某知名歌手因技术故障导致假唱被当场揭穿，现场观众一片哗然。</p><p><strong>候选事件三：某美食博主卫生问题大曝光</strong><br>一位拥有数百万粉丝的美食博主的后厨被曝光，卫生状况令人作呕，与其视频中展现的精致形象天差地别。</p><p>投票通道现已开启，快来为你心目中的"本月最离谱"投上一票吧！</p>`,
    category: 'contest',
    categoryName: '每日大赛专区',
    image: 'https://readdy.ai/api/search-image?query=voting%20poll%20concept%20with%20dramatic%20lighting%2C%20checkmark%20and%20cross%20symbols%2C%20dark%20election%20theme%2C%20red%20and%20gold%20highlights%2C%20mysterious%20ballot%20box%2C%20cinematic%20atmosphere%2C%20dramatic%20shadow%20play&width=800&height=450&seq=article-contest-02&orientation=landscape',
    date: '2026-07-31',
    views: 135600,
    tags: ['每日大赛', '月度投票', '翻车事件', '网友评选'],
    author: '大赛主持人',
    isHot: true,
    isNew: false,
  },
  {
    id: 'article-9',
    title: '某知名餐饮连锁品牌后厨卫生状况触目惊心',
    excerpt: '一段在某知名餐饮连锁品牌后厨偷拍的视频引发全网关注，画面中的卫生状况令人不忍直视...',
    content: `<p>一段在某知名餐饮连锁品牌后厨偷拍的视频今日在社交平台引发全网关注。视频画面中的卫生状况令人触目惊心，与该品牌对外宣传的"干净卫生"形象形成鲜明对比。</p><p>视频中可以看到，厨房地面污水横流，食材随意堆放在地上，工作人员未佩戴手套直接接触食品，甚至还出现了蟑螂在操作台上爬行的画面。</p><p>据拍摄者透露，这段视频是在该品牌位于某一线城市的一家门店后厨拍摄的。拍摄者表示自己曾是这家店的员工，因为实在看不下去才选择曝光。</p><p>视频发布后，该品牌迅速登上热搜。大量网友表示再也不敢去这家店消费了。更有消费者表示要联合维权，要求品牌方赔偿。</p><p>市场监管部门已经介入调查。如果视频内容属实，该门店将面临停业整顿甚至吊销许可证的处罚。</p>`,
    category: 'zone1',
    categoryName: '黑料一区',
    image: 'https://readdy.ai/api/search-image?query=dirty%20restaurant%20kitchen%20scene%20with%20dramatic%20lighting%2C%20food%20safety%20violation%2C%20dark%20greasy%20atmosphere%2C%20industrial%20kitchen%20chaos%2C%20pest%20control%20issue%2C%20red%20warning%20theme%2C%20investigative%20journalism%20style&width=800&height=450&seq=article-zone1-04&orientation=landscape',
    date: '2026-07-30',
    views: 189300,
    tags: ['餐饮卫生', '后厨曝光', '食品安全', '品牌危机'],
    author: '食安调查员',
    isHot: true,
    isNew: false,
  },
  {
    id: 'article-10',
    title: '某招聘平台被指贩卖求职者个人信息给第三方',
    excerpt: '多名求职者反映在某知名招聘平台注册后频繁收到骚扰电话，调查发现该平台涉嫌将用户信息出售给第三方...',
    content: `<p>多名求职者近日向本网反映，在某知名招聘平台注册并投递简历后，开始频繁收到各种来路不明的骚扰电话和垃圾短信。经深入调查发现，该平台涉嫌将求职者的个人信息出售给第三方机构。</p><p>一位受害者表示："我在这个平台注册了不到一周，就开始接到各种贷款、保险、培训机构的推销电话。他们甚至连我的学历、工作经验都一清二楚，太可怕了。"</p><p>网络安全专家对该平台的App进行了技术分析，发现其存在将用户数据上传至多个第三方服务器的行为。这些数据传输并未在用户协议中明确告知用户。</p><p>更令人担忧的是，这些被泄露的信息包括求职者的真实姓名、手机号码、身份证号、学历信息以及详细的工作履历，完整程度令人震惊。</p><p>目前，个人信息保护相关部门已经对此事展开调查。如果指控属实，该平台可能面临严厉的法律制裁。</p>`,
    category: 'zone2',
    categoryName: '黑料二区',
    image: 'https://readdy.ai/api/search-image?query=data%20privacy%20breach%20concept%2C%20personal%20information%20leak%2C%20digital%20security%20threat%2C%20dark%20hacker%20theme%2C%20red%20warning%20alert%2C%20mysterious%20figure%20with%20laptop%2C%20dark%20web%20aesthetic%2C%20dramatic%20lighting&width=800&height=450&seq=article-zone2-04&orientation=landscape',
    date: '2026-07-29',
    views: 98700,
    tags: ['信息泄露', '招聘平台', '个人隐私', '数据安全'],
    author: '隐私卫士',
    isHot: false,
    isNew: false,
  },
  {
    id: 'article-11',
    title: '每日大赛特别篇：年度最佳爆料记者评选启动',
    excerpt: '每日大赛专区年度特别企划——最佳爆料记者评选正式启动，回顾过去一年中为网友带来精彩爆料的各位记者...',
    content: `<p>每日大赛专区年度特别企划正式启动！在过去的一年里，我们见证了无数精彩的爆料，每一个令人震惊的黑料背后，都离不开那些冒着风险深入调查的记者们。</p><p>今天，我们正式启动"年度最佳爆料记者"评选活动，邀请广大网友为你们心目中的最佳记者投出宝贵的一票。</p><p><strong>候选记者一：深夜爆料君</strong><br>代表作：《某顶流明星私密聚会照片流出》，以独到的新闻嗅觉和多篇独家爆料闻名。</p><p><strong>候选记者二：食安调查员</strong><br>代表作：《某知名餐饮连锁品牌后厨卫生状况触目惊心》，专注食品安全领域的深度调查。</p><p><strong>候选记者三：影视圈探长</strong><br>代表作：《知名导演与女演员不伦恋曝光》，深耕影视娱乐圈内幕多年。</p><p>投票截止日期为本月底，获奖记者将获得51黑料网年度荣誉证书和特别奖励。</p>`,
    category: 'contest',
    categoryName: '每日大赛专区',
    image: 'https://readdy.ai/api/search-image?query=journalism%20award%20ceremony%20concept%2C%20golden%20microphone%20on%20dark%20stage%2C%20press%20conference%20atmosphere%2C%20dramatic%20spotlight%2C%20investigative%20reporting%20theme%2C%20red%20carpet%20with%20dark%20background%2C%20prestigious%20award%20vibe&width=800&height=450&seq=article-contest-03&orientation=landscape',
    date: '2026-07-28',
    views: 78900,
    tags: ['每日大赛', '年度评选', '最佳记者', '爆料表彰'],
    author: '大赛组委会',
    isHot: false,
    isNew: false,
  },
  {
    id: 'article-12',
    title: '某国际品牌涉嫌在华使用双重标准，产品质量远逊海外版',
    excerpt: '消费者测评机构对比发现，某国际知名品牌在中国市场销售的产品与海外版本存在显著质量差异...',
    content: `<p>一家权威消费者测评机构今日发布了一份令人震惊的对比报告。报告显示，某国际知名品牌在中国市场销售的产品，与在欧美市场销售的同型号产品存在显著的质量差异。</p><p>测评团队从中国、美国和欧洲分别购买了同款产品进行拆解对比。结果发现，中国市场版本在材料用料、工艺精度和安全配置等多个方面都明显不如海外版本。</p><p>例如，该产品在中国版使用的外壳材料是普通塑料，而欧美版则使用了更高级的金属合金材料。关键的内部零部件也存在以次充好的情况。</p><p>更令人气愤的是，中国版的售价反而比海外版更贵。换算成人民币后，中国消费者实际支付的价格比美国消费者高出约25%。</p><p>品牌方面目前尚未对此事做出回应。消费者权益保护组织表示，将密切关注此事进展，必要时将采取法律行动。</p>`,
    category: 'zone1',
    categoryName: '黑料一区',
    image: 'https://readdy.ai/api/search-image?query=product%20quality%20comparison%20concept%2C%20two%20identical%20products%20side%20by%20side%20with%20different%20quality%2C%20dark%20consumer%20testing%20lab%2C%20magnifying%20glass%20detail%2C%20red%20warning%20labels%2C%20dramatic%20industrial%20lighting%2C%20investigative%20style&width=800&height=450&seq=article-zone1-05&orientation=landscape',
    date: '2026-07-27',
    views: 107200,
    tags: ['双重标准', '国际品牌', '产品质量', '消费者权益'],
    author: '质量监督员',
    isHot: false,
    isNew: false,
  },
];